import {
  getHotelFunnelReturnUrl,
  type IntegrationContext,
} from "@/lib/checkout/integration-source";

export const CompletionCtaTargets = [
  { title: "Custom URL", value: "customUrl" },
  { title: "Partner return URL", value: "partnerReturnUrl" },
  { title: "Back to payment", value: "backToPayment" },
] as const;

export type CompletionCtaTarget =
  (typeof CompletionCtaTargets)[number]["value"];

export function isCompletionCtaTarget(
  value: unknown,
): value is CompletionCtaTarget {
  return CompletionCtaTargets.some((target) => target.value === value);
}

type ResolveCtaUrlArgs = {
  target?: string | null;
  cmsUrl?: string | null;
  integrationContext: IntegrationContext;
  backToPaymentUrl?: string | null;
  /**
   * Existing hotel-funnel docs have no target. Primary CTAs keep mapping to
   * the partner return URL; secondary CTAs keep their CMS URL.
   */
  legacyHotelMapsToPartnerReturn: boolean;
};

export function resolveCtaUrl({
  target,
  cmsUrl,
  integrationContext,
  backToPaymentUrl,
  legacyHotelMapsToPartnerReturn,
}: ResolveCtaUrlArgs): string | null | undefined {
  if (target === "backToPayment") {
    return backToPaymentUrl ?? null;
  }

  if (target === "customUrl") {
    return cmsUrl;
  }

  const partnerReturnUrl = getHotelFunnelReturnUrl(integrationContext);

  if (target === "partnerReturnUrl") {
    return partnerReturnUrl ?? cmsUrl;
  }

  if (legacyHotelMapsToPartnerReturn && partnerReturnUrl) {
    return partnerReturnUrl;
  }

  return cmsUrl;
}
